// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"d0f922a0","363":"f12d92bc","496":"48e06c82"}[chunkId] + ".chunk.js";
};